export default __webpack_public_path__ + "static/media/Workload Management.9d7ae92f.png";